import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import NotePage from './Note';
import Login from './Signin';
import Dashboard from './Dashboard';
import Landing from './Landing';
import { Analytics } from "@vercel/analytics/react";
import theme from './theme/theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Analytics/>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signup" element={<Login />} />
          <Route path="/signin" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/note/:noteID" element={<NotePage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;

